import { Menu } from "@mui/icons-material"
import { AppBar, Box, Drawer, IconButton, styled, Toolbar } from "@mui/material"
import { DRAWER_WIDTH, HEADER_HEIGHT } from "utils/constants"

import { IDrawerContainer } from "./Header.types"

export const HeaderContainer = styled(Box)(() => ({
  display: "flex",
  minHeight: `${HEADER_HEIGHT}px`,
  marginBottom: "100rem"
}))

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: `${theme.zIndex.drawer + 1}`,
  minHeight: `${HEADER_HEIGHT}px`,
  width: "100%",
  backgroundColor: theme.palette.common.white,
  boxShadow: "none"
}))

export const StyledToolbar = styled(Toolbar)(() => ({
  display: "flex",
  minHeight: `${HEADER_HEIGHT}px !important`
}))

export const DisplayNameNotificationsContainer = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  justifyContent: "flex-start",
  alignItems: "center"
}))

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(2),
  color: theme.palette.common.black
}))

export const StyledMenuIcon = styled(Menu)(({ theme }) => ({
  height: theme.spacing(3),
  width: theme.spacing(3)
}))

export const DrawerContainer = styled(Box)<IDrawerContainer>(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    flexShrink: "0"
  }
}))

export const DrawerDesktop = styled(Drawer)(({ theme }) => ({
  display: "block",
  [theme.breakpoints.up("md")]: {
    display: "block"
  },
  [theme.breakpoints.down("md")]: {
    display: "none"
  },
  "& .MuiDrawer-paper": {
    boxSizing: "border-box",
    width: DRAWER_WIDTH,
    borderWidth: 0
  }
}))

export const DrawerMobile = styled(Drawer)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "block"
  },
  [theme.breakpoints.up("md")]: {
    display: "none"
  },
  "& .MuiDrawer-paper": {
    boxSizing: "border-box",
    width: DRAWER_WIDTH,
    borderWidth: 0
  }
}))

export const NavigationLinkContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none"
  }
}))
